  <template>
  <jet-form-section @submitted="updatePassword">
    <template #title> {{ t("title") }} </template>

    <template #description>
      {{ t("description") }}
    </template>

    <template #form>
      <div class="col-span-6 sm:col-span-4">
        <ui-input
          ref="current_password"
          :invalid="'current_password' in form.errors"
          :error="form.errors.current_password"
          type="password"
          :label="t('current_password')"
          v-model="form.current_password"
        ></ui-input>
      </div>

      <div class="col-span-6 sm:col-span-4">
        <ui-input
          ref="password"
          :invalid="'password' in form.errors"
          :error="form.errors.password"
          type="password"
          :label="t('password')"
          v-model="form.password"
        ></ui-input>
      </div>

      <div class="col-span-6 sm:col-span-4">
        <ui-input
          :invalid="'password_confirmation' in form.errors"
          :error="form.errors.password_confirmation"
          type="password"
          :label="t('password_confirmation')"
          v-model="form.password_confirmation"
        ></ui-input>
      </div>
    </template>

    <template #actions>
      <ui-button :disabled="form.processing">
        {{ t("save") }}
      </ui-button>
    </template>
  </jet-form-section>
</template>

<script>
import JetFormSection from "@/Jetstream/FormSection";
import { useI18n } from "vue-i18n";

export default {
  components: {
    JetFormSection,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      form: this.$inertia.form(
        {
          current_password: "",
          password: "",
          password_confirmation: "",
        },
        { key: "updatePassword" }
      ),
    };
  },

  methods: {
    updatePassword() {
      this.form.put(route("user-password.update"), {
        errorBag: "updatePassword",
        preserveScroll: true,
        onSuccess: () => this.form.reset(),
        onError: () => {
          if (this.form.errors.password) {
            this.form.reset("password", "password_confirmation");
            this.$refs.password.$refs.input.focus();
          }

          if (this.form.errors.current_password) {
            this.form.reset("current_password");
            this.$refs.current_password.$refs.input.focus();
          }
        },
      });
    },
  },
};
</script>

<i18n>
{
  "es": {
    "title": "Actualizar contraseña",
    "description": "Asegúrate que tu cuenta tenga una contraseña segura.",
    "current_password": "Contraseña actual",
    "password": "Nueva contraseña",
    "password_confirmation": "Confirmación de contraseña",
    "save": "Guardar"
  }
}
</i18n>